import i from "classnames";
import r, { forwardRef as O, useCallback as x } from "react";
import { TypographyComponent as f } from "../typography/typography-component.esm.js";
import { buildResponsiveSize as j } from "../utils/buildResponsiveSize.esm.js";
import { formatPrice as y } from "../utils/formatPrice.esm.js";
import { useSizeAttrs as T } from "../utils/hooks/useSizeAttrs.esm.js";
import { ScreenReaderOnly as E } from "../utils/sr-only.esm.js";
import { priceConfig as q } from "./config.esm.js";
const D = "_price__saleContainer_hcfh5_1", G = "_price_hcfh5_1", H = "_price__basicPrice_hcfh5_111", J = "_price__savePrice_hcfh5_120", K = "_price__prevPrice_hcfh5_125", t = {
  price__saleContainer: D,
  price: G,
  price__basicPrice: H,
  price__savePrice: J,
  price__prevPrice: K
}, {
  basicPrice: l,
  prevPrice: N,
  savePrice: S
} = q, L = O(
  ({
    price: m,
    dataTestId: e,
    headingTag: b = "h3",
    isEuro: h = !1,
    prevPrice: s = 0,
    saving: g = 0,
    showCurrentFrom: v = !1,
    showPreviousFrom: R = !1,
    showSave: $ = !0,
    size: c = "l",
    className: d,
    ...z
  }, B) => {
    const C = y(m), P = y(s), k = y(g), a = x(
      (p) => {
        const [_] = j(c);
        if (_) {
          const n = {};
          return Object.keys(c).forEach((u) => {
            n[u] = p.font.size[c[u]];
          }), n;
        }
        return p.font.size[c];
      },
      [c]
    ), o = x(
      (p, _, n = !1) => `${n ? _ ? "Save up to " : "Save " : _ ? "From " : ""}${h ? "€" : "£"}${p}`,
      [h]
    ), A = T(c, {});
    return /* @__PURE__ */ r.createElement(
      "div",
      {
        "data-testid": e,
        ref: B,
        ...z,
        ...A,
        "data-has-prev-price": P && P !== "0" ? "" : void 0,
        className: i(t.price, "fuse-price", d)
      },
      !!m && !s && /* @__PURE__ */ r.createElement(
        f,
        {
          tag: b,
          size: a(l),
          type: l.font.type,
          dataTestId: e && `${e}__basic`,
          className: i(t.price__basicPrice, "fuse-price__basic-price")
        },
        o(C, v)
      ),
      !!m && !!s && /* @__PURE__ */ r.createElement(
        "div",
        {
          className: i(t.price__saleContainer, "fuse-price__sale-price-wrapper")
        },
        /* @__PURE__ */ r.createElement(
          f,
          {
            className: i(t.price__basicPrice, "fuse-price__basic-price"),
            size: a(l),
            type: l.font.type,
            tag: b,
            dataTestId: e && `${e}__basic`
          },
          /* @__PURE__ */ r.createElement(E, null, "Current sale price is "),
          o(C, v)
        ),
        $ && /* @__PURE__ */ r.createElement(
          f,
          {
            className: i(t.price__savePrice, "fuse-price__save-price"),
            size: a(S),
            type: S.font.type,
            dataTestId: e && `${e}__save`
          },
          "(",
          o(k, v, !0),
          ")"
        )
      ),
      !!s && /* @__PURE__ */ r.createElement(
        f,
        {
          className: i(t.price__prevPrice, "fuse-price__prev-price"),
          size: a(N),
          type: N.font.type,
          dataTestId: e && `${e}__prev`
        },
        /* @__PURE__ */ r.createElement(E, null, "Regular price was "),
        o(P, R)
      )
    );
  }
);
L.displayName = "Price";
export {
  L as Price
};
